import { CALLBACK_BUTTON_TEXT_EXPERIMENT } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

//TODO:Удалить селектор в CD-190865

export const selectCallbackButtonTextExperimentActive = (state: IApplicationState) => {
  const { experiments } = state;

  return isAbUseExperimentActive(experiments, CALLBACK_BUTTON_TEXT_EXPERIMENT, 'enabled');
};
